import { Alert, Button, Spinner } from "@softmax/design-system";

export type AccountReadState<T> =
  | { readonly status: "loading" }
  | { readonly status: "error"; readonly message: string }
  | {
      readonly status: "ready";
      readonly data: T;
      readonly refresh?:
        | { readonly status: "refreshing" }
        | { readonly status: "error"; readonly message: string };
    };

export function AccountReadStatus({
  state,
  onRetry,
}: {
  readonly state:
    | { readonly status: "loading" | "refreshing" }
    | { readonly status: "error"; readonly message: string };
  readonly onRetry: () => void;
}) {
  if (state.status === "error")
    return (
      <Alert tone="danger">
        {state.message}{" "}
        <Button size="sm" onClick={onRetry}>
          Try again
        </Button>
      </Alert>
    );

  return (
    <output>
      <Spinner /> {state.status === "loading" ? "Loading…" : "Refreshing…"}
    </output>
  );
}
